// extracted by mini-css-extract-plugin
export default {"RSVP":"RSVP_RSVP__0JWWo","Legal":"RSVP_Legal__WmPVp","TermsOfUse":"RSVP_TermsOfUse__rTCV9"};